import { useMediaQuery } from '@mui/material';
import { bluePlanetTheme } from 'ui/theme';

export function useBreakpoints() {
  const isMobile = useMediaQuery(bluePlanetTheme.breakpoints.down('sm'));
  const isTabletDown = useMediaQuery(bluePlanetTheme.breakpoints.down('md'));
  const isLgDown = useMediaQuery(bluePlanetTheme.breakpoints.down('lg'));
  const isXlDown = useMediaQuery(bluePlanetTheme.breakpoints.down('xl'));

  return { isMobile, isTabletDown, isLgDown, isXlDown };
}
